/* eslint-disable no-case-declarations */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Granite Bagas
*/

import React, { useState, useRef } from 'react';
import {
  View,
  PanResponder,
  StyleSheet,
  TouchableOpacity,
  Dimensions,
} from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { captureRef } from 'react-native-view-shot';
import Toast from 'react-native-toast-message';
import SociollaText from '@components/sociolla/SociollaText';
import Input from '@components/form/Input';
import CheckBox from '@components/form/CheckBox';

import FormLabel from '@components/form/common/FormLabel';
import ModalFull from '@components/modal/ModalFull';
import Button from '@components/form/Button';
import Image from '@components/global/Image';
import ModalHalf from '@components/modal/ModalHalf';
import { KeyboardWrapper } from '@components/screen/Layout';

import Colors from '@global/colors';
import { isWeb, isWebPlatform, isNative } from '@global/screens';
import { uploadS3, chooseImagePicker } from '@global/helpers';
import { showPopup } from '@/store/modal';
import { useDispatch } from 'react-redux';
import { showAlert } from '@/store/global';
import { ScrollView } from 'react-native';
import moment from 'moment-timezone';

const dimension = Dimensions.get('window');

const DRAW_DIMENSION = {
  width: '100%',
  height: isWeb ? 200 : dimension.height - 250,
};

const ESignature = ({
  testID,
  label,
  onChange,
  esignImage,
  onlyDraw = false,
  onChangeName = () => {},
  onChangeDone = () => {},
  showName = false,
  name = '',
  showTick = false,
  hasEdit = false,
  isRequired = true,
  dateSigned = '',
}) => {
  const dispatch = useDispatch();
  const svgRef = useRef(null);
  const canvasRef = useRef(null);
  const viewShotRef = useRef(null);

  const [path, setPath] = useState(''); // Store the entire path
  const [agreed, setAgreed] = useState(false);
  const [isDrawing, setIsDrawing] = useState(false);
  const [signImage, setSignImage] = useState(esignImage);
  const [uploadImage, setUploadImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showOption, setShowOption] = useState(false);
  const [activeTab, setActiveTab] = useState('draw');
  const [dimensions, setDimensions] = useState({
    width: DRAW_DIMENSION.width,
    height: DRAW_DIMENSION.height,
  });
  const [viewBox, setViewBox] = useState('');
  const [showTnc, setShowTnc] = useState(false);

  const TABS = onlyDraw
    ? [{ label: 'Draw', value: 'draw' }]
    : [
        { label: 'Draw', value: 'draw' },
        { label: 'Upload Image', value: 'upload' },
      ];

  const TermsAndConditions = () => {
    const terms = [
      'SDI dari waktu ke waktu berhak untuk menetapkan harga atas barang-barang yang dipasok olehnya kepada Pengecer berdasarkan Kerjasama ini (“Barang”). Pengecer hanya dapat menjual Barang ke konsumen akhir dan tidak melakukan distribusi Barang di luar daripada areanya. Pengecer hanya dapat menguasai dan menjual Barang sepanjang Kerjasama ini berlaku dan tanpa adanya permintaan dari instansi berwenang, prinsipal dan/atau SDI (yang disebabkan karena pelanggaran Pengecer) untuk menghentikan penjualan atau distribusi.',
      'Pengecer wajib melakukan pembayaran atas setiap pembelian Barang kepada SDI secara penuh dan tepat waktu. Pembayaran yang sah adalah pembayaran melalui transfer ke rekening atas nama SDI yang disampaikan SDI secara terpisah (untuk pembayaran transfer dan Giro) atau apabila pembayaran dilakukan secara tunai, pembayaran yang atasnya telah diberikan invoice asli dan resmi dari SDI kepada Pengecer. Apabila karena satu dan lain hal, pembayaran belum secara penuh diterima oleh SDI hingga melewati Jangka Waktu Bayar sebagaimana tercantum di Form Pengajuan Toko Baru, maka: (i) Pengecer dengan ini memberikan kuasa kepada SDI untuk melakukan pemotongan tagihan dari Pengecer kepada SDI dalam hal SDI memiliki tunggakan atau kewajiban pembayaran kepada Pengecer; dan/atau (ii) sepanjang SDI hendak atau bersedia menerima retur atas Barang yang masih berada dalam penguasaan Pengecer namun dalam kondisi baru serta layak dijual kembali, maka Pengecer dengan ini memberikan segala kuasa yang diperlukan (jika ada) bagi SDI untuk melakukan penarikan kembali atas Barang retur dari lokasi penyimpanan Pengecer atas biaya Pengecer dan karenanya nilai retur yang dapat diterima SDI tersebut akan diperhitungkan kembali secara proporsional untuk mengurangi sisa pembayaran (utang) yang belum dilunasi oleh Pengecer.',
      'Pengecer wajib menandatangani berita acara penerimaan (sebagaimana relevan) Barang atas setiap Barang yang diterimanya secara sesuai. Pengecer wajib mengikuti seluruh standar operasional prosedur (“SOP”) yang berlaku di SDI seperti tetapi tidak terbatas pada pemesanan, pengiriman, pembayaran, promosi serta retur/pengembalian Barang dari Pengecer kepada SDI. Dalam hal SDI menggunakan sistem elektronik untuk pelaksanaan SOP maka Pengecer dengan ini akan menyetujui kebijakan privasi serta syarat dan ketentuan yang berlaku dari sistem elektronik tersebut.',
      'Atas permintaan SDI dengan cara dan bentuk apapun, Pengecer wajib untuk memberikan kepada SDI data penjualan Barang serta dokumen-dokumen legalitas lainnya yang dipandang perlu oleh SDI.',
      'Pengecer wajib menjaga kerahasiaan atas seluruh informasi diketahuinya termasuk akses atas layanan sistem elektronik yang disediakan SDI (jika ada) sehubungan dengan pelaksanaan Kerjasama ini, meskipun Kerjasama telah berakhir.',
      'Pengecer dengan ini menyatakan bahwa dirinya memiliki segala legalitas, perizinan, sertifikasi dan persetujuan dalam bentuk dan nama apapun berdasarkan hukum, untuk melaksanakan Kerjasama ini termasuk tetapi tidak terbatas dalam melakukan penjualan atas Barang.',
      'Kecuali disetujui secara tertulis oleh SDI atau berdasarkan permintaan SDI yang disetujui Pengecer, (i). Pengecer dilarang untuk mendapatkan pasokan Barang dari pihak lain selain SDI; dan (ii) menggunakan hak kekayaan intelektual SDI dan/atau Barang demi kepentingan apapun, baik secara langsung ataupun tidak langsung. Pengecer juga dilarang menggunakan hak kekayaan intelektual milik pihak lain terkait Barang, dan Pengecer atas permintaan SDI wajib menghentikan (termasuk menghapus) segala publikasi yang telah dilakukannya terhadap Barang.',
      'Kerjasama ini berlaku secara terus menerus kecuali dalam hal salah satu pihak mengakhiri Kerjasama dengan pemberitahuan 30 (tiga puluh) hari sebelumnya. Mengesampingkan ketentuan sebelumnya, SDI tanpa suatu kompensasi apapun dapat mengakhiri kerjasama ini secara seketika dalam hal Pengecer melanggar satu atau ketentuan Kerjasama ini (termasuk pelanggaran dalam melakukan kewajiban pembayarannya), SDI memutuskan untuk menghentikan peredaran Barang pada wilayah Pengecer, SDI kehilangan haknya untuk mengedarkan atau memasok Barang dan/atau terdapat perintah dari otoritas berwenang untuk prinsipal Barang untuk menghentikan peredaran Barang. SDI dari waktu ke waktu dapat mengubah seluruh ketentuan dalam Kerjasama ini, dan dalam hal Pengecer tidak menyetujui perubahan tersebut maka baik Pengecer ataupun SDI dapat mengakhiri Kerjasama ini.',
      'Setiap pengakhiran atas Kerjasama ini: a) tidak serta merta mengakhiri setiap kewajiban masing-masing pihak kepada pihak lainnya yang telah timbul sebelum berakhirnya Kerjasama ini; dan b) mengesampingkan Pasal 1226 KUHPerdata. Dalam hal terjadi pengakhiran tanpa ada pelanggaran dari Pengecer dan terdapat sisa Barang belum terjual dalam kondisi baik dan layak jual berdasarkan inspeksi sisa stok Barang oleh SDI, maka SDI atas kewenangannya dengan atau tanpa mengesampingkan ketentuan relevan dalam Kesepakatan ini, dapat melakukan pembelian Barang sisa tersebut dengan harga pembelian setara dengan harga jual Barang dari SDI kepada Pengecer dikurangi biaya pengiriman Barang sisa tersebut ke gudang SDI.',
      'SDI dan Pengecer sepakat bahwa ketentuan Force Majeure dalam hukum dapat berlaku dalam Kesepakatan ini apabila keadaan Force Majeure merupakan penyebab langsung atas tidak dapat dilaksanakan kewajiban, tidak dapat diduga dan di luar kendali dari SDI atau Pengecer (sebagaimana relevan).',
      'Dalam hal timbul perselisihan di antara para pihak atas Kerjasama, dan tidak tercapai musyawarah dalam jangka waktu 30 hari, maka perselisihan akan diselesaikan melalui Badan Arbitrase Nasional Indonesia (“BANI”) di Jakarta sesuai peraturan BANI yang berlaku.',
      'Kerjasama ini bersifat menyeluruh antara para pihak dan tidak ada perjanjian atau persyaratan dalam bentuk apa pun antara Para Pihak, dalam bentuk lisan maupun tulisan selain dari Kesepakatan. Dalam hal terdapat perubahan, perubahan tersebut hanya berlaku apabila dilakukan secara tertulis, konfirmasi e-mail, atau adanya coretan yang kemudian di-paraf oleh SDI dan Pengecer.',
      'Apabila salah satu isi dari Kesepakatan ini menjadi tidak berlaku karena suatu hukum, maka isi Kesepakatan yang lain akan tetap berlaku sehingga SDI Dalam hal salah satu pihak melanggar ketentuan Kerjasama ini dan pihak lain tidak memberikan teguran atas pelanggaran tersebut, maka dengan tidak diberikannya teguran tidak dapat diartikan sebagai suatu persetujuan atau izin atas pelanggaran tersebut.',
      'Pengecer menjamin bahwa dirinya tidak melakukan penawaran, berjanji tidak akan menawarkan, membujuk, berjanji untuk memberi atau membayar, atau mengesahkan pembayaran uang apa pun termasuk tetapi tidak terbatas pada setiap personel atau utusan SDI baik secara langsung atau tidak langsung, untuk tujuan: (i) mempengaruhi tindakan atau keputusan SDI; (ii) mendapatkan keuntungan yang tidak patut dari SDI; (iii) melakukan praktek kolusi maupun nepotisme dengan pihak manapun dari SDI; (iv) melakukan atau mengabaikan tindakan yang melanggar kewajibannya yang sah menurut hukum dan/atau peraturan perundang-undangan yang berlaku.',
    ];

    return (
      <View
        style={{
          flex: 1,
          maxHeight: isWeb ? '70vh' : '100%',
          overflowY: isWeb ? 'auto' : 'visible',
        }}>
        <ScrollView
          style={styles.containerTnc}
          contentContainerStyle={styles.contentTnc}>
          <SociollaText style={styles.headerTnc}>
            LAMPIRAN I FORM PENGAJUAN TOKO BARU
          </SociollaText>
          <SociollaText style={styles.paragraphTnc}>
            Pengecer dan PT Semesta Distribusi Indonesia (“SDI”) dengan ini
            setuju untuk mengikatkan diri berdasarkan Form Pengajuan Toko Baru
            dan lampiran-lampirannya (“Kerjasama”) dengan ketentuan lebih lanjut
            sebagai berikut:
          </SociollaText>
          {terms.map((term, index) => (
            <View key={index} style={styles.listItemContainer}>
              <View style={styles.listItemIndex}>
                <SociollaText style={styles.listItemNumber}>
                  {index + 1}.
                </SociollaText>
              </View>
              <View style={styles.listItemTextWrapper}>
                <SociollaText style={styles.listItemText}>{term}</SociollaText>
              </View>
            </View>
          ))}
          <Button
            style={{
              width: '100%',
              height: 40,
              borderRadius: 8,
              backgroundColor: Colors.primary,
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 20,
            }}
            onPress={() => {
              setAgreed(true);
              onChangeDone(true);
              setShowTnc(false);
              setTimeout(() => {
                setShowModal(true);
              }, 50);
            }}
            title={
              <SociollaText
                type="bold"
                style={{
                  fontSize: 14,
                  letterSpacing: 0.5,
                  color: Colors.white,
                }}>
                Accept Terms & Conditions
              </SociollaText>
            }
          />
        </ScrollView>
      </View>
    );
  };

  const panResponder = useRef(
    PanResponder.create({
      onStartShouldSetPanResponder: () => true,
      onPanResponderGrant: (evt) => {
        setIsDrawing(true);
        const { locationX, locationY } = evt.nativeEvent;
        setPath((prevPath) => `${prevPath} M ${locationX},${locationY}`);
      },
      onPanResponderMove: (evt) => {
        const { locationX, locationY } = evt.nativeEvent;
        setPath((prevPath) => `${prevPath} L ${locationX},${locationY}`);
      },
      onPanResponderRelease: () => {
        setIsDrawing(false);
      },
    }),
  ).current;

  const handleSubmit = async (image) => {
    try {
      const url = await uploadS3({
        file: image,
        isImage: true,
      });
      if (!url) {
        Toast.show({
          text1: 'Failed to upload signature. Please try again.',
          type: 'error',
        });
        return;
      }
      setSignImage(url);
      onChange(url);
      setShowModal(false);
      setPath('');
      setUploadImage(null);
    } catch (error) {
      Toast.show({
        text1: 'A system error occurred',
        type: 'error',
      });
    }
  };

  function parsePath(path) {
    const commands = path.match(/[MLC][^MLC]*/g); // Split commands (M, L, C) and their parameters
    return commands.map((cmd) => {
      const type = cmd[0]; // Get the command type (M, L, C)
      const values = cmd.slice(1).trim().split(/[ ,]+/).map(Number); // Get the coordinates/parameters
      return { type, values };
    });
  }

  function calculateBoundingBox(svgPathData) {
    const commands = parsePath(svgPathData);

    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;

    let currentX = 0;
    let currentY = 0;

    // Helper function to update bounding box values
    function updateBounds(x, y) {
      minX = Math.min(minX, x);
      minY = Math.min(minY, y);
      maxX = Math.max(maxX, x);
      maxY = Math.max(maxY, y);
    }

    commands.forEach((command) => {
      const { type, values } = command;

      switch (type) {
        case 'M': // Move to (x, y)
        case 'L': // Line to (x, y)
          currentX = values[0];
          currentY = values[1];
          updateBounds(currentX, currentY);
          break;

        case 'C': // Cubic Bézier curve (x1, y1, x2, y2, x, y)
          // For simplicity, we only handle the endpoint (x, y) for bounding box calculation
          const x = values[4];
          const y = values[5];
          updateBounds(x, y);
          break;

        // Add more cases here for other SVG commands like Quadratic curves, Arcs, etc.

        default:
          break;
      }
    });

    // Return the bounding box (minX, minY) to (maxX, maxY)
    const width = maxX - minX;
    const height = maxY - minY;
    return { minX, minY, maxX, maxY, width, height };
  }

  // Convert SVG to PNG for Web
  const addSignature = async () => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    const bbox = calculateBoundingBox(path);
    // Add padding to the bounding box values
    const padding = 10;
    const paddedMinX = bbox.minX - padding;
    const paddedMinY = bbox.minY - padding;
    const paddedWidth = bbox.width + 2 * padding;
    const paddedHeight = bbox.height + 2 * padding;

    // eslint-disable-next-line no-unused-vars

    let uri;
    if (!isNative) {
      uri = await new Promise((resolve) => {
        const canvas = document.createElement('canvas');
        canvas.width = paddedWidth;
        canvas.height = paddedHeight;
        const ctx = canvas.getContext('2d');

        ctx.strokeStyle = 'black';
        ctx.lineWidth = 3;

        const commands = path.match(/[ML][^ML]*/g) || [];
        ctx.beginPath();
        commands.forEach((cmd) => {
          const type = cmd[0];
          const values = cmd.slice(1).trim().split(/[ ,]+/).map(Number);
          if (type === 'M') {
            ctx.moveTo(values[0] - paddedMinX, values[1] - paddedMinY);
          }
          if (type === 'L') {
            ctx.lineTo(values[0] - paddedMinX, values[1] - paddedMinY);
          }
        });
        ctx.stroke();

        resolve(canvas.toDataURL('image/png'));
      });
    } else {
      uri = await captureRef(viewShotRef.current, {
        format: 'png',
        quality: 0.95,
        result: 'data-uri',
      });
    }

    const fileName = `${new Date().getTime()}.png`;
    if (isWebPlatform) {
      await handleSubmit({
        uri,
        filename: fileName,
        type: 'image/png',
      });
    } else {
      const RNFS = require('react-native-fs');
      const [, dataPart] = uri.split(',');
      const filePath = `${RNFS.TemporaryDirectoryPath}${fileName}`;
      await RNFS.writeFile(filePath, dataPart, 'base64');
      await handleSubmit({
        uri: `file://${filePath}`,
        filename: fileName,
        type: 'image/png',
      });
    }
    dispatch(showPopup({ name: 'isLoading', value: false }));
  };

  const handleUploadImage = async () => {
    await handleSubmit(uploadImage);
  };

  const handleCloseModal = () => {
    setShowOption(false);
    setShowModal(false);
    setPath('');
    setUploadImage(null);
    setViewBox('');
    setDimensions({
      width: DRAW_DIMENSION.width,
      height: DRAW_DIMENSION.height,
    });
  };

  const handleUploadImageOption = async () => {
    const image = await chooseImagePicker(1000, false);
    setUploadImage(image);
    if (!isWeb) {
      await handleSubmit(image);
      setShowOption(false);
    }
  };

  const handleOption = async (option) => {
    if (option == 'draw') {
      setShowOption(false);
      setShowModal(true);
      setActiveTab(option);
    } else {
      await handleUploadImageOption();
    }
  };

  const handleClearBox = () => {
    setPath('');
    setViewBox('');
    setDimensions({
      width: DRAW_DIMENSION.width,
      height: DRAW_DIMENSION.height,
    });
  };

  return (
    <View testID={testID} style={styles.container}>
      <FormLabel label={label} isRequired={isRequired} />
      {signImage ? (
        <View style={styles.imageContainer}>
          <Image style={styles.signatureImage} source={signImage} />
          {(hasEdit && onlyDraw) || !onlyDraw ? (
            <TouchableOpacity
              onPress={() => {
                dispatch(
                  showAlert({
                    show: true,
                    title: 'Delete E-Signature',
                    description:
                      'E-signature will be deleted. Do you want to proceed?',
                    onCallback: (val) => {
                      setSignImage(null);
                      onChange('');
                      onChangeName('');
                      onChangeDone(false);
                      handleClearBox();
                      setAgreed(false);
                    },
                  }),
                );
              }}
              style={styles.removeButton}>
              <Image
                style={{
                  width: 20,
                  height: 20,
                  marginRight: 5,
                  marginTop: 5,
                }}
                width={20}
                height={20}
                svg={true}
                source={require('@assets/img/icons/close-circle-blue.svg')}
              />
            </TouchableOpacity>
          ) : null}
        </View>
      ) : (hasEdit && onlyDraw) || !onlyDraw ? (
        <TouchableOpacity
          style={styles.placeholderSignature}
          onPress={() => {
            setActiveTab('draw');
            if (isWeb) {
              setShowModal(true);
            } else {
              setShowOption(true);
            }
          }}>
          <SociollaText
            type="bold"
            style={{
              fontSize: 14,
              letterSpacing: 0.5,
              color: Colors.blue0,
            }}>
            ADD E-SIGNATURE
          </SociollaText>
        </TouchableOpacity>
      ) : (
        <View style={styles.placeholderSignature}>
          <SociollaText
            type="bold"
            style={{
              fontSize: 14,
              letterSpacing: 0.5,
              color: Colors.blue0,
            }}>
            E-SIGNATURE
          </SociollaText>
        </View>
      )}
      {signImage && showName ? (
        <View style={{ height: 22, justifyContent: 'left', marginTop: 10 }}>
          {name ? (
            <SociollaText
              type="medium"
              style={{
                fontSize: 12,
                color: '#0072FF',
                textAlign: 'left',
              }}>
              {name}
            </SociollaText>
          ) : null}
        </View>
      ) : (
        <View
          style={{ height: 22, justifyContent: 'left', marginTop: 10 }}></View>
      )}

      <View style={{ height: 22, justifyContent: 'left', marginBottom: 10 }}>
        <SociollaText
          style={{
            fontSize: 10,
            color: '#999999',
            textAlign: 'left',
          }}>
          {'Date:'}{' '}
          {signImage && dateSigned
            ? moment(dateSigned).format('DD MMM YYYY')
            : '-'}
        </SociollaText>
      </View>

      <ModalFull
        title="Add E-Signature"
        show={showModal}
        onClose={handleCloseModal}>
        {isWeb ? (
          <View style={styles.tabContainer}>
            <View style={styles.tabWrapper}>
              {TABS.map((item, idx) => (
                <TouchableOpacity
                  style={[
                    styles.tabItem,
                    item.value == activeTab ? styles.tabItemActive : {},
                  ]}
                  activeOpacity={0.8}
                  onPress={() => setActiveTab(item.value)}
                  key={idx}>
                  <SociollaText
                    style={[
                      styles.tabItemText,
                      item.value == activeTab ? styles.tabItemTextActive : {},
                    ]}>
                    {item.label}
                  </SociollaText>
                </TouchableOpacity>
              ))}
            </View>
          </View>
        ) : (
          false
        )}
        {activeTab == 'draw' ? (
          <KeyboardWrapper
            keyboardVerticalOffset={100}
            contentContainerStyle={{ paddingBottom: 30 }}
            scrollEnabled={!isDrawing}>
            <View style={styles.tabItemContainer}>
              <View style={styles.tabItemItemContainer}>
                <View style={styles.signatureTitle}>
                  <SociollaText>Sign in the provided Box</SociollaText>
                  <TouchableOpacity
                    onPress={handleClearBox}
                    style={{ padding: 5 }}>
                    <SociollaText style={{ color: Colors.blue0 }}>
                      Clear Box
                    </SociollaText>
                  </TouchableOpacity>
                </View>
                <View style={styles.signatureContainer}>
                  <View
                    style={{
                      width: dimensions.width,
                      height: dimensions.height,
                      borderColor: Colors.grey5,
                      borderWidth: 1,
                      borderRadius: 8,
                    }}>
                    <View
                      {...panResponder.panHandlers}
                      style={{
                        width: dimensions.width,
                        height: dimensions.height,
                      }}
                      ref={viewShotRef}>
                      {!isNative ? (
                        <svg
                          {...(viewBox ? { viewBox } : {})}
                          height={dimensions.height}
                          width={dimensions.width}
                          style={{
                            backgroundColor: 'transparent',
                            display: 'block',
                          }}>
                          <path
                            d={path}
                            stroke="black"
                            strokeWidth="3"
                            fill="none"
                          />
                        </svg>
                      ) : (
                        <Svg
                          {...(viewBox ? { viewBox } : {})}
                          height={dimensions.height}
                          width={dimensions.width}
                          ref={svgRef}
                          // eslint-disable-next-line react-native/no-color-literals
                          style={{ backgroundColor: 'transparent' }}>
                          <Path
                            d={path}
                            stroke="black"
                            strokeWidth="3"
                            fill="none"
                          />
                        </Svg>
                      )}
                    </View>
                  </View>

                  {isWeb && (
                    <canvas ref={canvasRef} style={{ display: 'none' }} />
                  )}
                  {showName && (
                    <View
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        flexDirection: 'column',
                        width: '100%',
                        marginTop: 12,
                      }}>
                      <Input
                        label="Full Name"
                        value={name}
                        isRequired={true}
                        isNumeric={false}
                        onChangeText={(text) => onChangeName(text)}
                      />
                    </View>
                  )}
                  {showTick && (
                    <View
                      style={{
                        flexDirection: 'row',
                        alignItems: 'flex-start',
                        marginTop: 20,
                      }}>
                      <CheckBox
                        value={agreed}
                        checked={agreed}
                        onChange={(val) => {
                          if (!agreed) {
                            setShowModal(false);
                            setTimeout(() => {
                              setShowTnc(true);
                            }, 50);
                          } else {
                            setAgreed(false);
                            onChangeDone(false);
                          }
                        }}
                      />
                      <SociollaText style={{ flex: 1, marginLeft: 10 }}>
                        I have read, understood, provided correct information,
                        and agree with the customer registration form and its
                        attachments.
                      </SociollaText>
                    </View>
                  )}
                  <View
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    <Button
                      type="primary"
                      rounded
                      buttonStyle={{
                        width: isWeb ? 120 : 100,
                        marginVertical: 20,
                      }}
                      disabledStyle={{
                        marginVertical: 20,
                        width: isWeb ? 120 : 100,
                      }}
                      disabled={
                        (!showName && !path) ||
                        (showName && !showTick && (!name || !path)) ||
                        (showName && showTick && (!name || !agreed || !path))
                      }
                      title={
                        <SociollaText
                          type="bold"
                          style={{
                            fontSize: 14,
                            letterSpacing: 0.5,
                            color: Colors.white,
                          }}>
                          Add
                        </SociollaText>
                      }
                      onPress={addSignature}
                    />
                  </View>
                </View>
              </View>
            </View>
          </KeyboardWrapper>
        ) : (
          false
        )}
        {activeTab == 'upload' ? (
          <View style={styles.tabItemContainer}>
            <View style={styles.tabItemItemContainer}>
              <FormLabel label="Upload e-signature image" />
              {uploadImage ? (
                <View
                  style={{
                    flex: 1,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    // backgroundColor: Colors.grey5,
                    padding: 10,
                    width: '70%',
                  }}>
                  <SociollaText
                    style={{
                      fontSize: 14,
                    }}>
                    {uploadImage.filename}
                  </SociollaText>
                  <TouchableOpacity
                    onPress={() => {
                      setUploadImage(null);
                    }}>
                    <Image
                      style={{
                        width: 20,
                        height: 20,
                      }}
                      width={20}
                      height={20}
                      svg={true}
                      source={require('@assets/img/icons/close-circle-blue.svg')}
                    />
                  </TouchableOpacity>
                </View>
              ) : (
                <Button
                  type="default"
                  rounded
                  buttonStyle={{ width: 100 }}
                  title={
                    <SociollaText
                      type="bold"
                      style={{
                        fontSize: 14,
                        letterSpacing: 0.5,
                      }}>
                      Upload
                    </SociollaText>
                  }
                  onPress={handleUploadImageOption}
                />
              )}
            </View>

            <Button
              type="primary"
              rounded
              buttonStyle={{ width: 120, marginVertical: 20 }}
              disabledStyle={{ paddingVertical: 10, paddingHorizontal: 40 }}
              disabled={!uploadImage}
              title={
                <SociollaText
                  type="bold"
                  style={{
                    fontSize: 14,
                    letterSpacing: 0.5,
                    color: Colors.white,
                  }}>
                  Add
                </SociollaText>
              }
              onPress={handleUploadImage}
            />
          </View>
        ) : (
          false
        )}
      </ModalFull>

      {/* Signature selection on mobile */}
      <ModalHalf
        title="Add E-Signature"
        visible={showOption}
        maxWidth="100%"
        spaceFromTop={false}
        onClose={handleCloseModal}>
        <View style={{ width: '100%' }}>
          <View
            style={{
              width: '100%',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <TouchableOpacity
              style={styles.esignOption}
              onPress={async () => await handleOption('draw')}>
              <SociollaText
                type="bold"
                style={{
                  marginHorizontal: 10,
                }}>
                Draw
              </SociollaText>
            </TouchableOpacity>
            {!onlyDraw && (
              <TouchableOpacity
                style={styles.esignOption}
                onPress={async () => await handleOption('upload')}>
                <SociollaText
                  type="bold"
                  style={{
                    marginHorizontal: 10,
                  }}>
                  Upload Image
                </SociollaText>
              </TouchableOpacity>
            )}
          </View>
        </View>
      </ModalHalf>

      <ModalFull
        title="Customer Registration Form Terms and Conditions"
        show={showTnc}
        onClose={() => {
          setShowTnc(false);
          setTimeout(() => {
            setShowModal(true);
          }, 50);
        }}
        maxWidth={'100%'}>
        {TermsAndConditions()}
      </ModalFull>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    borderWidth: 1,
    borderColor: Colors.grey5,
    padding: 10,
    borderRadius: 5,
    marginBottom: 15,
  },
  containerTnc: {
    flex: 1,
    backgroundColor: '#fff',
    padding: 15,
  },
  imageContainer: {
    flex: 1,
    minHeight: 100,
    // backgroundColor: Colors.grey5,
    flexDirection: 'row',
    position: 'relative',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
  },
  placeholderSignature: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 100,
    // backgroundColor: Colors.grey5,
  },
  signatureContainer: {
    flex: 1,
    ...(isWeb
      ? {
          justifyContent: 'center',
          alignItems: 'center',
        }
      : {}),
  },
  signatureTitle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  tabContainer: {
    width: '100%',
    padding: 15,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: Colors.white,
    borderRadius: 5,
    zIndex: 10,
  },
  tabWrapper: {
    flexDirection: 'row',
  },
  tabItemContainer: {
    flex: 1,
    alignItems: 'center',
    ...(isWeb
      ? {
          justifyContent: 'center',
        }
      : {
          marginTop: 15,
        }),
  },
  tabItemItemContainer: {
    width: '90%',
    flex: 1,
  },
  tabItem: {
    paddingVertical: 7,
    marginRight: 20,
    borderBottomColor: Colors.transparent,
    borderBottomWidth: 2,
  },
  tabItemActive: {
    borderBottomColor: Colors.blue0,
  },
  tabItemText: {
    fontSize: 13,
    color: Colors.grey1,
  },
  tabItemTextActive: {
    color: Colors.black0,
  },
  esignOption: {
    width: '90%',
    paddingVertical: 10,
    marginVertical: 5,
  },
  signatureImage: {
    width: '100%',
    maxWidth: 300,
    height: undefined,
    aspectRatio: 3,
    resizeMode: 'contain',
    // backgroundColor: Colors.grey5,
  },
  removeButton: {
    position: 'absolute',
    top: 5,
    right: 5,
    zIndex: 10,
  },
  contentTnc: {
    paddingBottom: 30,
  },
  headerTnc: {
    fontWeight: 'bold',
    fontSize: 16,
    marginBottom: 18,
  },
  paragraphTnc: {
    fontSize: 13,
    marginBottom: 25,
  },
  listItemContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 10,
  },
  listItemIndex: {
    width: 20,
    marginRight: 6,
  },
  listItemNumber: {
    fontSize: 13,
    lineHeight: 20,
  },
  listItemTextWrapper: {
    flex: 1,
  },
  listItemText: {
    fontSize: 13,
    lineHeight: 20,
    textAlign: 'justify',
  },
});

export default ESignature;
